<div class="containAll">

  <main-page></main-page>

  <div data-spy="scroll" data-target="#list-example" data-offset="0" class="scrollspy-example">

    <introduction></introduction>

    <quote></quote>

    <interview></interview>

    <div class="hamburger" (click)="showMenu()">
      <div class="bar1"></div>
      <div class="bar2"></div>
      <div class="bar3"></div>
    </div>

    <timeline></timeline>

  </div>

  <div class="credits">
    <pre>إعداد: لوتشيا صقر -  شاتابدي راج</pre>
    <pre>غرافيكس: كريستيان نعيمة -  أندريا خوري بولس</pre>
    <pre>تطوير الويب: جسيكا عبد المسيح - جسيكا الشاطر</pre>
    <pre>إشراف: أ. بريجيتا القسيس -  د. ماريا بو زيد</pre>
  </div>

  <div class="disclaimer">
    تمّ إنتاج هذه القصة بالشراكة مع جامعة سيدة اللويزة NDU في إطار تعاون ضمن مختبر افكار ضم طلابًا من قسم الصحافة، قسم
    التصميم وقسم علوم الكومبيوتر، بهدف تشجيع الابتكار في المحتوى الإعلامي وتشجيع العمل المشترك بين صناع المحتوى
    والعاملين في التكنولوجيا.
  </div>

  <div class="lastLine">
    COPYRIGHT © 2022 ALL RIGHTS RESERVED.
  </div>

</div>